/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { areTitleWordsCapitalized } from 'src/shared/app/locale/settings/localeSettings';
import { goBack } from 'src/shared/core/util/navigationUtils';
import { capitalize, capitalizeWords } from 'src/shared/core/util/stringUtil';
import TopBar from 'src/shared/ui/component/navigation/TopBar';
import TopBarWithBackButton from 'src/shared/ui/component/navigation/TopBarWithBackButton';

import type { TopBarProps } from 'src/shared/ui/component/navigation/type/topBarTypes';

type Props = TopBarProps & {
  backTo?: string,
  variant?: typeof backButton,
  // Self passed
  history: Object,
};

const AppTopBar = (props: Props): React.Node => {
  const { title, cancelLabel, handleCancel, backTo, variant, history } = props;

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { locale } = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const newProps = {
    ...props,
    title: title
      ? areTitleWordsCapitalized(locale)
        ? capitalizeWords(title)
        : capitalize(title)
      : undefined,
    handleCancel: backTo ? () => goBack(history, backTo) : handleCancel,
  };

  return (backTo && !cancelLabel) || variant === backButton ? (
    <TopBarWithBackButton {...newProps} />
  ) : (
    <TopBar {...newProps} />
  );
};

// Make variants available
export * from 'src/shared/ui/component/navigation/TopBar';

export const backButton = Symbol();

export default compose(React.memo, withRouter)(AppTopBar);
